module.exports = __webpack_public_path__ + "assets/images/pages/fundivisa/fundivisa-1.png?8e66617d";